<template>
  <div class="outspiwerclass">
    <div class="spiwerjsclass">
      <div class="leftbtn">
        <img src="../assets/left.png" />
      </div>
      <div class="swiper">
        <swiper @click="test" :options="swiperOption">
          <swiper-slide v-for="item in imageList"
            ><img :src="item" @click="test"
          /></swiper-slide>
        </swiper>
      </div>
      <div class="rightbtn">
        <img src="../assets/right.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'Main',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 0,
        slidesPerView: 3, // 一屏显示的slide个数
        centeredSlides: true, // 居中的slide是否标记为active，默认是最左active,这样样式即可生效
        slideToClickedSlide: true, // 点击的slide会居中
        loop: true, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
        on: {
          // 该方法中的this都指代swiper本身
          tap: function() {
            console.log('点击的位置', this.activeIndex);
          },
        },
        navigation: {
          nextEl: '.rightbtn',
          prevEl: '.leftbtn',
        },
      },
      imageList: [
        'https://image2.cqcb.com/d/file/topics/activity/2022-05-31/5UggjbbP-1654009776260.jpg',
        'https://image2.cqcb.com/d/file/topics/activity/2022-05-31/nyiIMiEL-1654009777024.jpg',
        'https://image2.cqcb.com/d/file/topics/activity/2022-05-31/uwOGVuLB-1654009777931.jpg',
        // 'https://image2.cqcb.com/d/file/topics/activity/2022-05-31/k2AtDceh-1654009778595.jpg',
        // 'https://image2.cqcb.com/d/file/topics/activity/2022-06-07/Sw7pAXU0-1654573955653.jpg',
        // 'https://image2.cqcb.com/d/file/topics/activity/2022-06-07/Zg6xvzzp-1654573955392.jpg',
        // 'https://image2.cqcb.com/d/file/topics/activity/2022-06-20/vfr2Evaw-1655692688377.jpg',
        // 'https://image2.cqcb.com/d/file/topics/activity/2022-06-07/PtrymKCi-1654573955036.jpg',
      ],
    };
  },
  mounted() {},
  methods: {
    test(e) {
      // 默认会$event对象
      console.log(11, e);
    },
    //用方法控制轮播上下切换
    // prevSlide() {
    //   this.$refs.mySwiper.swiper.prevSlide;
    // },
    // nextSlide() {
    //   this.$refs.mySwiper.swiper.nextSlide;
    // },
    showimgdetail(inx) {
      console.log('indx:', inx);
      this.isshowimg = true;
      this.showimginx = inx;
    },
    changeshowimginx() {
      this.isshowimg = false;
      this.showimginx = -1;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import ('~@/common/styles/index.styl')
@import ('../style/variable.styl')
.outspiwerclass
    height: 100vh;
    width: 100%;
    margin 0 auto
    background-color blue
    .spiwerjsclass
      display flex
      width 100%
      .leftbtn
        height: 200px;
        width: 36px;
        position: relative;
        img
          position: absolute;
          width: 40px;
          height: 50px;
          bottom: 100px;
          z-index: 1001;
          left: 0
          border-radius: 5px;
      .rightbtn
        height: 200px;
        width: 36px;
        position: relative;
        left: calc(100% - 72px);
        img
          position: absolute;
          width: 40px;
          height: 50px;
          bottom: 100px;
          z-index: 1001;
          right: 0;
          border-radius: 5px;
      .swiper
        width 100%
        height 200px
        position absolute
      .swiper-container
        width 100%
        height 100%
      .swiper-wrapper
        width 100%
        height 100%
      .swiper-slide
        text-align center
        font-size 18px
        background #fff
        /* Center slide text vertically */
        display -webkit-box
        display -ms-flexbox
        display -webkit-flex
        display flex
        -webkit-box-pack center
        -ms-flex-pack center
        -webkit-justify-content center
        justify-content center
        -webkit-box-align center
        -ms-flex-align center
        -webkit-align-items center
        align-items center
        transition 300ms
        transform scale(0.5)
        img
          width: 150px
          height: 200px
          object-fit: cover
      .swiper-slide-active,
      .swiper-slide-duplicate-active
        transform scale(1)
</style>
